<script setup>
import { ref, computed, useAttrs } from 'vue'
import dealStatus from '@/utils/dealStatus'

defineOptions({inheritAttrs: false})
const attrs = useAttrs()

const props = defineProps({
  statusCode: { type: String, required: true, default: '??' },
})

const cssClasses = computed(() => {
  const arr = []
  // add the bg color class using the status code
  arr.push(dealStatus.cssClass(props.statusCode))
  // add any classes attached to the component so we can customize style if needed
  if (attrs.class) {
    arr.push(attrs.class)
  }
  return arr.join(' ')
})
</script>

<template lang="pug">
.deal-status-coloring.py-1.px-2.border-round-lg.text-center(
  :class="cssClasses"
) {{ statusCode }}
</template>